import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import CreatePost from '../../components/CreatePost';
import UsersPost from '../../components/UsersPost';
import SuggestUsers from '../../components/SuggestUsers';
import AsideContacts from '../../components/AsideContacts';
import AsideNewFeed from '../../components/AsideNewFeed';
import ConnectRequest from '../../components/ConnectRequest';
import {database} from '../../firebase'
import Zendesk from "react-zendesk";
import './home.css'

function HomeScreen(){
    const { currentUser } = useSelector((state) => ({
        currentUser: state.profile.currentUser,
        creditzIds: state.profile.creditzIds,
      }));
    
    function updateStatus(){
        let userRef = database.ref('users/' + currentUser.uid);
        userRef.update({'status': 'Active'})
    }
    const ZENDESK_KEY = "ox2CGXixN3Ez7nKuf3IjEVttiYMR4qHd6V6kxSrL";

    const setting = {
        color: {
            theme: "#7117a5"
        },
        launcher: {
            chatLabel: {
                "en-US": "Need Help"
            }
        },
        contactForm: {
            fields: [
                { id: "description", prefill: { "*": "My pre-filled description" } }
            ]
        }
    };

    document.title = "Home";
    useEffect(()=>{
  updateStatus()

    });

    return (
        <>
        <AsideNewFeed></AsideNewFeed>
        <section className="main-content">
            <div className="middle-box">
                <div className="row">
                    <div className="col-xl-8 col-lg-8 mb-5">

                        <Zendesk defer zendeskKey={ZENDESK_KEY} {...setting} onLoaded={() => console.log('is loaded')} />
                        <script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=d94b55a5-34af-46b2-ae92-c070a3afe58f"> </script>

                        <UsersPost></UsersPost>

                        <SuggestUsers></SuggestUsers>                  
                    </div>
                    {/* // */}
                    <div className="col-xl-4 col-lg-4 ps-lg-0 mb-5">
                        <AsideContacts></AsideContacts>
                    </div>
                </div>
            </div>
        </section>
        {/* Right Aside */}
        </>
    );
}

export default HomeScreen;
